import { useState } from 'react'
import emailjs from 'emailjs-com'
import '../styles/landing.css'

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  })
  const [status, setStatus] = useState('idle') // idle | sending | success | error

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setStatus('sending')
    emailjs.send(
      'service_kw1qhin', // Service ID
      'template_4v4o44v', // Template ID
      formData,
      'V6yn2-sCVHkSsHbvT' // User ID (Public Key)
    )
    .then(() => {
      setStatus('success')
      setFormData({ name: '', email: '', subject: '', message: '' })
      setTimeout(() => setStatus('idle'), 5000)
    }, (error) => {
      console.error(error.text)
      setStatus('error')
      setTimeout(() => setStatus('idle'), 5000)
    })
  }

  const contactInfo = [
    { icon: '✉️', label: 'Email', value: 'vortexadmision@gmail.com', href: 'mailto:vortexadmision@gmail.com' },
    { icon: '🕐', label: 'Horario', value: 'Lunes a Viernes, 8:00 AM - 5:00 PM' },
    { icon: '⚡', label: 'Tiempo de respuesta', value: '24 horas' },
    { icon: '📍', label: 'Soporte', value: 'Atención a todas las instituciones' },
  ]

  const faqs = [
    {
      q: '¿Cómo funciona la suscripción a Vortex EXANI-II?',
      a: 'Vortex EXANI-II ofrece acceso completo a simuladores oficiales de 168 reactivos, herramientas de Inteligencia Artificial para resolver dudas, generación ilimitada de cuestionarios y biblioteca de audio.'
    },
    {
      q: '¿Los reactivos están alineados a la guía oficial del Ceneval?',
      a: 'Sí, todos nuestros bancos de reactivos y simuladores respetan la estructura oficial del EXANI-II: 3 opciones de respuesta (A, B, C), ponderación de áreas transversales y módulos de conocimientos específicos.'
    },
    {
      q: '¿Sirve para el proceso de ingreso a universidades que usan el EXANI-II?',
      a: 'Totalmente. El examen EXANI-II de Ceneval es utilizado por la mayoría de universidades públicas, autónomas e instituciones de educación superior en México como parte de sus procesos de admisión.'
    }
  ]

  return (
    <section id="contact" className="section section-alt">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>Contacto</h2>
          <p className="section-subtitle">
            ¿Tienes preguntas sobre Vortex EXANI-II o el proceso de admisión? Nuestro equipo está aquí para ayudarte.
          </p>
        </div>

        <div className="contact-grid">
          {/* Contact Info */}
          <div>
            <h3 style={{ marginBottom: 'var(--spacing-xl)' }}>
              Información de contacto
            </h3>

            <div className="contact-cards">
              {contactInfo.map((item, index) => (
                <div key={index} className="contact-card">
                  <div className="contact-card-icon">{item.icon}</div>
                  <div>
                    <span className="contact-card-label">{item.label}</span>
                    {item.href ? (
                      <a href={item.href} className="contact-card-value">{item.value}</a>
                    ) : (
                      <span className="contact-card-value">{item.value}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="contact-info-section">
              <h4>Preguntas frecuentes</h4>
              <div className="faq-box">
                {faqs.map((faq, index) => (
                  <details key={index} open={index === 0}>
                    <summary>{faq.q}</summary>
                    <p>{faq.a}</p>
                  </details>
                ))}
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <h3 style={{ marginBottom: 'var(--spacing-xl)' }}>
              Envíanos un mensaje
            </h3>

            <form onSubmit={handleSubmit} className="contact-form">
              <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                <label htmlFor="name" className="form-label">
                  Nombre completo *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  autoComplete="name"
                  className="form-input"
                />
              </div>

              <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                <label htmlFor="email" className="form-label">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  autoComplete="email"
                  className="form-input"
                />
              </div>

              <div style={{ marginBottom: 'var(--spacing-lg)' }}>
                <label htmlFor="subject" className="form-label">
                  Asunto *
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  autoComplete="off"
                  className="form-input"
                />
              </div>

              <div style={{ marginBottom: 'var(--spacing-xl)' }}>
                <label htmlFor="message" className="form-label">
                  Mensaje *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  className="form-input"
                  style={{ resize: 'vertical' }}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary"
                style={{ width: '100%' }}
                disabled={status === 'sending'}
              >
                {status === 'sending' ? 'Enviando...' : 'Enviar mensaje'}
              </button>

              {status === 'success' && (
                <div className="form-feedback form-feedback--success">
                  ✓ ¡Gracias por tu mensaje! Te responderemos pronto.
                </div>
              )}
              {status === 'error' && (
                <div className="form-feedback form-feedback--error">
                  ✕ Hubo un error al enviar el mensaje. Intenta de nuevo.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}
